import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    centerAreaDueDetailsList: { loading: false, data: null, error: null },
};

export const centerAreaDueDetailsSlice = createSlice({
  name: "centerAreaDueDetails",
  initialState,
  reducers: {
    fetchCenterAreaDueDetailsListRequest: (state, action) => {
      state.centerAreaDueDetailsList.loading = true;
      state.centerAreaDueDetailsList.error = null;
    },
    fetchCenterAreaDueDetailsListSuccess: (state, action) => {
      state.centerAreaDueDetailsList.data = action.payload;
      state.centerAreaDueDetailsList.loading = false;
      state.centerAreaDueDetailsList.error = null;
    },
    fetchCenterAreaDueDetailsListFailure: (state, action) => {
      state.centerAreaDueDetailsList.data = null;
      state.centerAreaDueDetailsList.loading = false;
      state.centerAreaDueDetailsList.error = action.payload;
    },
  },
});

export const {
  fetchCenterAreaDueDetailsListRequest,
  fetchCenterAreaDueDetailsListSuccess,
  fetchCenterAreaDueDetailsListFailure,
} = centerAreaDueDetailsSlice.actions;

export const getCenterAreaDueDetailssListState = (store) =>
  store.centerAreaDueDetails?.centerAreaDueDetailsList;

export default centerAreaDueDetailsSlice.reducer;
